import AboutPage from './about-page';
export default AboutPage;